import { request } from '@umijs/max';

import { AddUserRequest, GetUserRequest, UserResponse } from '@/types';

export async function getUser({ id }: GetUserRequest): Promise<UserResponse> {
  return request(`users/${id}`, {
    method: 'GET',
  });
}

export async function getUsers(): Promise<UserResponse[]> {
  return request('users', {
    method: 'GET',
  });
}

export async function addUser(payload: AddUserRequest): Promise<UserResponse> {
  return request('users', {
    data: payload,
    method: 'POST',
  });
}

export async function editUser({ id, ...payload }: UserResponse): Promise<UserResponse> {
  return request(`users/${id}`, {
    data: payload,
    method: 'PATCH',
  });
}

export async function deleteUser({ id, ...payload }: UserResponse): Promise<UserResponse> {
  return request(`users/${id}`, {
    data: payload,
    method: 'DELETE',
  });
}
